import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { SUBSCRIPTIONS } from '../apiUrls';

const mutationUpdateSubscription = (onSuccess, onError) => {
    return {
        mutationFn: ({ allowedClientId, subscriptionId, planId }) => {
            return client.put(
                replaceParameters(SUBSCRIPTIONS.UPDATE.url, { subscriptionId: subscriptionId }),
                { planId: planId, allowedClientId: allowedClientId }
            );
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateSubscription;